import React from "react";
import { Link, useOutletContext } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { can } from "../ui";

/** Compact forbidden state for edition routes; backend RBAC still governs every data call. */
export function RequirePerm({ perms, label, children }) {
  const { access } = useOutletContext();
  if (can(access, ...perms)) return children;
  return (
    <div className="m-2 border border-red-300 bg-red-50 text-[12px] text-red-900 px-3 py-2 flex items-center gap-2 max-w-xl" data-testid="edition-forbidden">
      <ShieldAlert className="w-4 h-4 shrink-0" />
      <div><span className="font-bold">Forbidden</span> — {label} requires <code className="text-[11px]">{perms.join(" or ")}</code>. Your role does not include it.</div>
      <Link to="/dashboard" className="ml-auto underline text-red-800" data-testid="edition-forbidden-home">Home</Link>
    </div>
  );
}
